module.exports = __webpack_public_path__ + "static/media/etools.6588eddd.svg";